webpackJsonp([60],{

/***/ "+2bP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}.account-register__disclaimer{margin:0 0 8px;padding:12px 0;font-size:12px;letter-spacing:.3px;text-align:center;color:#666;line-height:1.5}.account-register__disclaimer a{color:#07a0bb;text-decoration:none;font-weight:500;-webkit-transition:color .2s ease;transition:color .2s ease}.account-register__disclaimer a:hover{color:#067e94;text-decoration:underline}.account-register__username-wraper{margin-bottom:4px}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/account/account-register-external/account-register-external.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,8BACE,eAAkB,AAClB,eAAgB,AAChB,eAAgB,AAChB,oBAAsB,AACtB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAClB,AACD,gCACI,cAAe,AACf,qBAAsB,AACtB,gBAAiB,AACjB,kCAAoC,AACpC,yBAA4B,CAC/B,AACD,sCACM,cAAe,AACf,yBAA2B,CAChC,AACD,mCACE,iBAAmB,CACpB","file":"account-register-external.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n.account-register__disclaimer {\n  margin: 0 0 8px 0;\n  padding: 12px 0;\n  font-size: 12px;\n  letter-spacing: 0.3px;\n  text-align: center;\n  color: #666;\n  line-height: 1.5;\n}\n.account-register__disclaimer a {\n    color: #07a0bb;\n    text-decoration: none;\n    font-weight: 500;\n    -webkit-transition: color 0.2s ease;\n    transition: color 0.2s ease;\n}\n.account-register__disclaimer a:hover {\n      color: #067e94;\n      text-decoration: underline;\n}\n.account-register__username-wraper {\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "E9c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_external_js__ = __webpack_require__("RSTw");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96e5e6ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_external_vue__ = __webpack_require__("NWOx");
function injectStyle (ssrContext) {
  __webpack_require__("JM8M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_external_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96e5e6ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_external_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JM8M":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+2bP");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4b7cefd1", content, true, {});

/***/ }),

/***/ "NWOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"disabled":_vm.isFormDisabled,"name":"email","type":"email","required":true,"maxLength":50,"validator":"email","autocomplete":"off","gtm":"Registration,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.emailConfirmation,"disabled":_vm.isFormDisabled,"name":"emailConfirmation","type":"email","required":true,"maxLength":50,"validator":"equalTo","equalTo":_vm.fields.email,"autocomplete":"off","gtm":"Registration,Email Confirmation","placeholder":"Confirm Email"},on:{"input":_vm.$v.fields.emailConfirmation.$touch},model:{value:(_vm.fields.emailConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "emailConfirmation", $$v)},expression:"fields.emailConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-register__username-wraper"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"name":"nickname","type":"text","required":true,"maxLength":14,"validation":_vm.$v.fields.username,"autocomplete":"off","placeholder":"Username","gtm":"Registration,Username"},on:{"input":_vm.$v.fields.username.$touch},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"account-register__disclaimer"},[_vm._v("\n          By clicking \"Create Account\",\n          you confirm that you are at least 18 years of age and have read the "),_c('router-link',{attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("Terms and Conditions")]),_vm._v(".\n        ")],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"label":"Create Account","disabled":_vm.invalidOrDisabled}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new ext_reg_form__title",staticStyle:{"margin-top":"0.5rem"}},[_vm._v("Complete registration with your email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RSTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase__ = __webpack_require__("OAqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_dataLayer__ = __webpack_require__("k37b");










var PROVIDER_FACEBOOK = 'Facebook';
var PROVIDER_TWITTER = 'Twitter';
var PROVIDER_GOOGLE = 'Google';
var CACHE_NAME = 'register-external';
var MAX_USERNAME_LENGTH = 14;
var MAX_EMAIL_LENGTH = 50;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* formMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_externalLinks__["a" /* default */]],
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* validators */].email, {
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(MAX_EMAIL_LENGTH)
      }),
      emailConfirmation: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* validators */].emailConfirmation('email'), {
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(MAX_EMAIL_LENGTH)
      }),
      username: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* validators */].username
    }
  },
  data: function data() {
    return {
      fields: {
        email: '',
        emailConfirmation: '',
        username: ''
      },
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['formDataCache'])),
  mounted: function mounted() {
    if (this.userInfo && this.userInfo.userName) {
      this.fields.username = this.getNormalizedSuggestedUserName(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.fields, this.formDataCache);
    }
    if (this.fields.email) {
      this.$v.fields.email.$touch();
    }
    if (this.fields.emailConfirmation) {
      this.$v.fields.emailConfirmation.$touch();
    }
  },

  watch: {
    userInfo: function userInfo() {
      this.fields.username = this.getNormalizedSuggestedUserName(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['registerExternal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'cacheFormData']), {
    closePopupAndRedirect: function closePopupAndRedirect() {
      var _this = this;

      this.setCurrentPopup();
      this.getExternalLogins({}).then(function (response) {
        _this.links = response.data;
        var provider = _this.userInfo.loginProvider;
        switch (provider) {
          case PROVIDER_FACEBOOK:
            _this.facebookLinkClick();
            break;
          case PROVIDER_TWITTER:
            _this.twitterLinkClick();
            break;
          case PROVIDER_GOOGLE:
            _this.googleLinkClick();
            break;
          default:
            break;
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: 'Create Account'
      }));
      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          email: this.fields.email,
          userName: this.fields.username
        };
        this.registerExternal(payload).then(this.formEnable).then(function () {
          __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('registeredExternal', true);
          _this2.closePopupAndRedirect();
        }).catch(function (error) {
          return _this2.formHandleErrors(error);
        });
      }
    },

    // Normalize only provider-suggested defaults (and cap at backend max length).
    // We intentionally do not re-normalize at submit time so the validated input value
    // the user sees is exactly what gets posted.
    getNormalizedSuggestedUserName: function getNormalizedSuggestedUserName(value) {
      if (!value) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default()(value).slice(0, MAX_USERNAME_LENGTH);
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.fields, { route: CACHE_NAME }));
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/60.159ed46b14ec6f4d668c.js